export default {
  CENTER: 1,
  BOTTOM: 2,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/title-position-values.js